import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import 'rxjs/add/observable/of';
import { environment } from '../../environments/environment';
var AuthService = /** @class */ (function () {
    function AuthService(http, localSt) {
        this.http = http;
        this.localSt = localSt;
        this.serverUrl = environment.serverUrl;
    }
    AuthService.prototype.logIn = function (data) {
        return this.http.post(this.serverUrl + 'customers/login', data);
    };
    AuthService.prototype.logOut = function () {
        return this.http.post(this.serverUrl + 'customers/logout', {}, {
            headers: new HttpHeaders().set('Authorization', this.localSt.retrieve('zenUser').token)
        });
    };
    AuthService.prototype.forgotPwd = function (data) {
        return this.http.post(this.serverUrl + 'customers/forgotpassword', data);
    };
    AuthService.prototype.resetPwd = function (data) {
        return this.http.put(this.serverUrl + 'customers/resetpassword', data);
    };
    AuthService.prototype.changePwd = function (data) {
        return this.http.put(this.serverUrl + 'customers/changepassword', data);
    };
    AuthService.prototype.signup = function (data) {
        return this.http.post(this.serverUrl + 'customers', data);
    };
    AuthService.prototype.updateProfile = function (data) {
        return this.http.put(this.serverUrl + 'customers', data);
    };
    AuthService.prototype.uploadProfileImage = function (data) {
        var boundary = Math.random().toString().substr(2);
        var headers = new HttpHeaders();
        headers.append('content-type', 'multipart/form-data; charset=utf-8; boundary=' + boundary);
        return this.http.post(this.serverUrl + 'customers/uploadimage', data, { headers: headers });
    };
    AuthService.prototype.getProfileDetails = function () {
        return this.http.get(this.serverUrl + 'customers/myprofile');
    };
    return AuthService;
}());
export { AuthService };



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts.pre-build-optimizer.js